// extracted by mini-css-extract-plugin
export default {"WhatsApp":"WhatsAppLink_WhatsApp__oENTv"};